import React, {ReactElement} from "react";
import {Link} from "react-router-dom";

export const Footer = (): ReactElement => {
    return <footer id="footer" className="footer border-top border-dark">
        <div className="footer-top">
            <div className="container">
                <div className="row gy-4">
                    <div className="col-lg-5 col-md-12 footer-info">
                        <Link to="/" className="logo d-flex align-items-center fw-bold fs-4"><img
                            src="/assets/img/title-text-singleline.webp" alt="Fairy Tale Fables" className="h-100"/></Link>
                        {/*<p></p>*/}
                    </div>
                    {/*<div className="col-lg-2 col-6 footer-links">
                        <h4>Useful Links</h4>
                    </div>
                    <div className="col-lg-2 col-6 footer-links">
                        <h4>Our Services</h4>
                    </div>*/}
                    <div className="col-lg-3 col-md-12 footer-contact text-center text-md-start">
                        <h4>Contact Us</h4>
                        <p>
                            Fairytale Software CaWa GmbH<br/>
                            Obere Augartenstraße 12-14/1/12<br/>
                            1020 Wien<br/>
                            Europe - Austria<br/>
                            E-Mail: <a className="text-black" href="mailto:support@fairytalefables.com">support@fairytalefables.com</a><br/>
                        </p>
                        <Link to="/app/delete" className="logo d-flex align-items-center text-danger fw-bold">
                            <span>Delete your Account here</span>
                        </Link>
                        <Link to="/assets/privacy-policy.html" rel="noopener noreferrer" target="_blank" className="logo d-flex align-items-center text-black">
                            <span>Privacy Policy</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="copyright">
                {new Date().getFullYear()} &copy; Copyright <strong>Fairytale Fables</strong>.<br/>
                All Rights Reserved
            </div>
        </div>
    </footer>;
};